import React, { useRef } from 'react';

type TiltCardProps = {
  children: React.ReactNode;
  className?: string;
};

const TiltCard: React.FC<TiltCardProps> = ({ children, className }) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const requestRef = useRef<number | null>(null);

  const handleMouseMove = (e: React.MouseEvent) => {
    if (requestRef.current) cancelAnimationFrame(requestRef.current);

    requestRef.current = requestAnimationFrame(() => {
      const card = cardRef.current;
      if (!card) return;

      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateX = ((y - centerY) / centerY) * -20;
      const rotateY = ((x - centerX) / centerX) * 20;

      card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    if (card) {
      card.style.transition = 'transform 0.4s ease';
      card.style.transform = 'rotateX(0deg) rotateY(0deg)';

      setTimeout(() => {
        if (card) card.style.transition = '';
      }, 400);
    }
  };

  return (
    <div
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={`[transform-style:preserve-3d] will-change-transform ${className}`}
      style={{
        perspective: '1000px',
      }}
    >
      {children}
    </div>
  );
};

export default TiltCard;
